import React, { ReactElement } from "react";

import { Button, Col, Row } from "react-bootstrap";

import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./BannerTextAndButton.module.scss";

const BannerTextAndButton = ({
  bannerContent,
  buttonLabel,
  href,
}: {
  bannerContent: string | ReactElement;
  buttonLabel: string;
  href: string;
}) => {
  return (
    <div className={classNames(styles["banner-container"], "px-3 px-md-0")}>
      <Row className={styles["banner-inner-container"]}>
        <Col md={9} className="px-0">
          <div className="monoBlack h4 mb-0">{bannerContent}</div>
        </Col>
        <Col md={3} className="md:px-0 d-flex pt-5 md:pt-0 md:justify-content-end">
          <Link to={href} target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" role="link" className={styles["banner-button"]}>
              {buttonLabel}
            </Button>
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default BannerTextAndButton;
